import DOMPurify from 'dompurify';
import marked from 'marked';
import { createLink } from '../services/lang';

export function parseMarkdown2Html(markdown: string): string {
    const betterMarkdown = addArtworkLinksToImage(markdown);
    const html = marked(betterMarkdown);
    const sanitizedHtml = DOMPurify.sanitize(html);
    return sanitizedHtml;
}

function addArtworkLinksToImage(text: string) {
    return text.replace(/#\d{4}/gm, (match) =>
        `[${match}](${createLink('/artwork/' + match.substr(1))})`
    );
}